import { createContext } from "react";

import { LazyValue, useLazyContext } from "~utils";

import { User } from "./user";

export function useAnalyticsUserPersistence(): useAnalyticsUserPersistenceReturn {
  return useLazyContext(AnalyticsUserPersistenceContext);
}

export type useAnalyticsUserPersistenceReturn = {
  upsertUser: (user: AnalyticsUser) => Promise<void>;
};

export type AnalyticsUser = Pick<
  User,
  | "converted"
  | "primarySport"
  | "role"
  | "boardVenues"
  | "boardPurposes"
  | "boardFrequency"
>;

export const AnalyticsUserPersistenceContext =
  createContext<LazyValue<useAnalyticsUserPersistenceReturn>>(undefined);
